import sales_manual from "@/services/sales_manual";

export default {
  async read({ commit, getters }, payload = { page: 1, limit: 200 }) {
    try {
      const data = getters.list;
      if (data.length > 0) {
        commit("SET_SALES_MANUAL_DATA", data);
      } else {
        const data = await sales_manual.read(payload);
        commit("SET_SALES_MANUAL_DATA", data);
        return data;
      }
    } catch (err) {
      console.info(err);
      throw err;
    }
  },
};
